<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-04-18 15:15:01
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveType\LeaveType.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_leaveType_list_title')"
    :addBtn="hasBtn('add-admin-leave-type')"
    pad="0"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.color="{ item }">
          <div style="max-width: 20px">
            <svg-icon
              size="24"
              :fill="item.color_code"
              iconClass="LabeledColour"
            />
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div small class="table-title">
            {{ $getCommonLangValue(item.leave_type_name) }}
          </div>
        </template>
        <template v-slot:item.abbr="{ item }">
          <div class="text--primary table-title">
            {{ $getCommonLangValue(item.leave_type_abbr) }}
          </div>
        </template>
        <template v-slot:item.leave_type_code="{ item }">
          <div class="text--primary table-title">
            {{ $getCommonLangValue(item.leave_type_code) }}
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-leave-type')"
            :editBtn="hasBtn('edit-admin-leave-type')"
            :viewBtn="hasBtn('view-admin-leave-type')"
            :title="$t('label_essweb_leaveType_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "LeaveType",
  computed: {},
  data() {
    return {
      showSelect: false,
      selected: [],
      totalCount: 0,
      search: "",
      headers: [
        {
          text: "label_essweb_list_components_tools_colorLabel",
          value: "color",
          width: 48,
          mrcSelected: false,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveType_list_leaveTypeNameLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.leave_type_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_leaveType_list_leaveTypeAbbrLabel",
          value: "abbr",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveTransactionPropertyGroup_form_codeLabel",
          value: "leave_type_code",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/leave-type/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/leave-type/edit/"
          : "/admin/leave-type/detail/") + uuid
      );
    },

    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/delete/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          color: "success",
          text: that.$t(
            "message_essweb_leaveType_list_deleteLeaveTypeSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
